import Typography from '@alltrails/core/components/Typography';
import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import styles from '../../components/PressCard/styles/styles.module.scss';
import yearOnTheTrails from './individual-press-releases/2023YearOnTheTrails';
import chatGPTPressRelease from './individual-press-releases/chatGPTPressRelease';
import CollaborativeListsPressRelease from './individual-press-releases/CollaborativeListsPressRelease';
import PublicLandsPressRelease from './individual-press-releases/PublicLandsPressRelease';
import liveSharePressRelease from './individual-press-releases/liveSharePressRelease';
import earthMonth2024 from './individual-press-releases/earthMonth2024';
import inAppPhotoGallery from './individual-press-releases/inAppPhotoGallery';
import SummerUpdate2024 from './individual-press-releases/SummerUpdate2024';
import AppleWatch2024 from './individual-press-releases/AppleWatch2024';
import { OldPressReleaseCard } from '@/components/OldPressCard';

const alltrailsLink = (
  <Link href="/" target="_blank">
    AllTrails
  </Link>
);

const alltrailsDotComLink = (
  <Link href="/" target="_blank">
    alltrails.com
  </Link>
);

const spectrumEquityLink = (
  <Link href="https://www.spectrumequity.com/" target="_blank">
    Spectrum Equity
  </Link>
);

const iosLink = (
  <Link href="https://apps.apple.com/us/app/alltrails-hike-bike-run/id405075943" target="_blank">
    iOS
  </Link>
);

const androidLink = (
  <Link href="https://play.google.com/store/apps/details?id=com.alltrails.alltrails" target="_blank">
    Android
  </Link>
);

const leaveNoTraceLink = (
  <Link href="https://lnt.org/" target="_blank">
    leave no trace
  </Link>
);

const petSmartLink = (
  <Link href="https://www.petsmart.com/" target="_blank">
    PetSmart
  </Link>
);

const plusLink = (
  <Link href="https://www.alltrails.com/plus" target="_blank">
    AllTrails+
  </Link>
);

const appleFinalistLink = (
  <Link href="https://www.apple.com/newsroom/2023/11/meet-the-2023-app-store-award-finalists/" target="_blank">
    <FormattedMessage defaultMessage="iPhone App of the Year finalists" />
  </Link>
);

const appOfTheYearLink = (
  <Link href="https://www.apple.com/newsroom/2023/11/apple-unveils-app-store-award-winners-the-best-apps-and-games-of-2023/" target="_blank">
    <FormattedMessage defaultMessage="iPhone App of the Year" />
  </Link>
);

const mentalHealthDaySource = (href: string) => {
  return (
    <Link href={href} target="_blank">
      <FormattedMessage defaultMessage="Source" />
    </Link>
  );
};

const pressLink = <Link href="mailto:press@alltrails.com">press@alltrails.com</Link>;

const oldPressReleases: OldPressReleaseCard[] = [
  AppleWatch2024,
  SummerUpdate2024,
  inAppPhotoGallery,
  earthMonth2024,
  liveSharePressRelease,
  PublicLandsPressRelease,
  CollaborativeListsPressRelease,
  yearOnTheTrails,
  chatGPTPressRelease,
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Receives Google Play ‘Best Of 2023’ Honorable Mention Award" />,
    date: 'December 4, 2023',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Receives Google Play ‘Best Of 2023’ Honorable Mention Award" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="December 4, 2023 – {alltrailsLink}, the world’s largest and most trusted outdoor platform, was honored by
          Google as one of the top Google Play apps of 2023. The app was named a Google Play “Best Of 2023 Honorable Mention” recipient
          and is recognized for its Wear OS Watch application which allows users to track their trail activity from their Wear OS watch.
          Google Play’s “Best of 2023” awards is Google’s largest annual editorial moment and celebrates both emerging and established applications
          that have produced high-quality content."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="AllTrails connects its users to the outdoors, helping people discover places they’ve never been and elevating their
          experience on the trail. By providing users with features to plan and explore confidently, AllTrails removes barriers to accessing
          the outdoors and helps millions of people around the world experience the mental and physical health benefits of time in nature.
          The free app boasts a community of more than 60 million people and has more than 420 thousand curated trail routes across every
          country worldwide."
          />
          <br />
          <FormattedMessage
            defaultMessage="“With over 3.5 million apps in the Play Store, AllTrails is honored to be among the few recognized by Google,” said
          Ron Schneidermann, Chief Executive Officer at AllTrails. “We are proud to be acknowledged for our work to help people around the world
          find their way outside, now with our Wear OS app. It’s a testament to the world-class and purpose-driven app our team has built.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="Earlier this year AllTrails launched its Wear OS app which helps trail-goers seamlessly explore and track their outdoor
          adventures. App capabilities include:"
          />
          <br />
          <ul>
            <li>
              <FormattedMessage defaultMessage="Tracking activity progress and viewing estimated distance remaining on a route" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Loading nearby routes and getting started on a trail right from your wrist" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Viewing your stats as you go" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Receiving wrong-turn alerts, buzzing your wrist when you step off path" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Ability to start, stop, pause and resume route recordings" />
            </li>
          </ul>
          <br />
          <FormattedMessage
            defaultMessage="The recognition celebrates the brand’s commitment to ongoing innovation. AllTrails continues to be the most recognized digital
          brand and category-leader in the outdoor activity sector."
          />
          <br />
          <FormattedMessage defaultMessage="About AllTrails" />
          <br className={styles.noMargin} />
          <FormattedMessage
            defaultMessage="AllTrails helps you find your way outside with detailed reviews and inspiration from a global community of
          trail-goers. Every day, AllTrails is inspired to help get more people outside so they can have healthy, authentic experiences and
          a deeper appreciation of the outdoors."
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Named Apple’s 2023 iPhone App of the Year" />,
    date: 'November 30, 2023',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Named Apple’s 2023 iPhone App of the Year" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="San Francisco, Calif. Nov 30, 2023 – {alltrailsLink},  the world's largest and most trusted
          outdoor platform, was awarded {appOfTheYearLink} by Apple, celebrating
          its outstanding approach to helping people explore the outdoors."
            values={{ alltrailsLink, appOfTheYearLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="The 2023 App Store Awards spotlight app and game developers who are providing users with
          meaningful experiences and inspiring cultural change. Out of nearly two million apps in the App Store, AllTrails
          is recognized as the iPhone App of the Year for its innovative experience, user-friendly design,
          and, according to Apple, “for helping the world find their way outside.“"
          />
          <br />
          <FormattedMessage
            defaultMessage="The team behind the AllTrails app is driven by the mission to share the outdoors
          with as many people in as many places as possible. By guiding users to plan
          and explore confidently, AllTrails removes barriers to accessing the outdoors and
          helps millions of people around the world experience the mental and physical health benefits of
          time in nature. The free app has cultivated a community of more than 60 million people and has
          more than 420 thousand curated trail routes across 191 countries."
          />
          <br />
          <FormattedMessage
            defaultMessage="“It’s an honor to have Apple’s App Store Editors recognize AllTrails’ dedication to getting people around the world outside,” said
          Ron Schneidermann, Chief Executive Officer at AllTrails. “This is an incredible milestone and a testament to our ongoing work of connecting people
          of all backgrounds, skills, and experiences to the outdoors,” he added. “We’re excited to continue to build our community and elevate their
          outdoor experiences with even more innovation in 2024.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="2023 has been a high-growth year for the San Francisco-based company, packed with platform updates. AllTrails introduced
          many new features to its product suite, such as:"
          />
          <br />
          <ul>
            <li>
              <FormattedMessage
                defaultMessage="Trail Previews - A game-changing 3D immersive video that helps users get a feel for any route,
              terrain, and elevation"
              />
            </li>
            <li>
              <FormattedMessage
                defaultMessage="Local Community Feed - An expanded community feature that helps inspire users through others' trail activities
              in the surrounding area. Trail-goers can browse the feed to check out trail activity in any location"
              />
            </li>
            <li>
              <FormattedMessage
                defaultMessage="Advanced Conditions - Weather conditions that update along every trail. Conditions include: temperature, mosquito index,
              predictive conditions based on recent weather, and historical weather"
              />
            </li>
            <li>
              <FormattedMessage
                defaultMessage="Stats & Achievements - A new and improved experience that helps users log their adventures and celebrate their time outside.
              Trail-goers can track progress, earn badges, and view an inspiring snapshot of completed outdoor activities"
              />
            </li>
            <li>
              <FormattedMessage
                defaultMessage="National Park Guides - Curated guides for over 200 National Parks with tips on where to go, what to do,
              and how to be prepared"
              />
            </li>
            <li>
              <FormattedMessage
                defaultMessage="Improved On-Trail Navigation - A tool that allows users to follow a planned route, record an actual route, and easily find
              the way back to the point of origin"
              />
            </li>
          </ul>
          <br />
          <FormattedMessage
            defaultMessage="AllTrails continues to be the most recognized digital brand and category-leader in the outdoor activity sector. In addition to
          this recent recognition, AllTrails is frequently featured as a 'Top 5 Health & Fitness App.'"
          />
          <br />
          <Typography variant="text100bold">
            <FormattedMessage defaultMessage="About AllTrails" />
          </Typography>
          <br className={styles.noMargin} />
          <FormattedMessage
            defaultMessage="AllTrails helps you find your way outside with detailed reviews and inspiration from a global community of trail-goers.
          Every day, AllTrails is inspired to help get more people outside so they can have healthy, authentic experiences and a deeper appreciation of the outdoors."
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Named iPhone App of the Year Finalist" />,
    date: 'November 14, 2023',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Named iPhone App of the Year Finalist" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="Hiking and outdoor recreation app is recognized for its innovative features that help connect people to the outdoors" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="San Francisco, November 14, 2023 – {alltrailsLink}, the world’s largest and most trusted outdoor platform, was featured today by Apple as
          one of three {appleFinalistLink}, a recognition by Apple’s global App Store Editors. Finalists in the iPhone App of the Year category help
          users discover more ways to explore and learn new skills. AllTrails is specifically being recognized for its innovative product set,
          user-friendly design, and, according to Apple’s announcement, “for helping the world find their way outside.”"
            values={{ alltrailsLink, appleFinalistLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="AllTrails connects its users to the outdoors, helping people discover places they’ve never been and elevating their experience on the trail.
          By providing users with features to plan and explore confidently, AllTrails removes barriers to accessing the outdoors and helps millions of
          people around the world experience the mental and physical health benefits of time in nature. The free app boasts a community of more than
          60 million people and has more than 420 thousand curated trail routes across every country worldwide."
          />
          <br />
          <FormattedMessage
            defaultMessage="“From Day One, our mission at AllTrails has been to help people get outside,” said Ron Schneidermann, Chief Executive Officer at AllTrails.
          “We’re constantly listening to our users and working to improve their outdoor experience,” he added. “This recognition underscores our
          team’s commitment to ongoing innovation, so that people of all backgrounds and skill levels can experience the goodness of the outdoors.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="The honor comes on the heels of a high-growth year for the brand, one that was packed with momentum and numerous product releases. In 2023,
          AllTrails introduced many new features to its product suite, such as:"
          />
          <br />
          <ul>
            <li>
              <FormattedMessage defaultMessage="Trail Previews - A game-changing 3D immersive video that helps users get a feel for any route, terrain, and elevation." />
            </li>
            <li>
              <FormattedMessage
                defaultMessage="Local Community Feed - The expanded Community feature helps users get inspired by others’ trail activities in the surrounding area.
              Trail-goers can browse the feed to check out trail activity in any location."
              />
            </li>
            <li>
              <FormattedMessage
                defaultMessage="Advanced Conditions - Users can see weather conditions along every trail. Conditions include: temperature, mosquito index, predictive
              conditions based on recent weather, and historical weather."
              />
            </li>
            <li>
              <FormattedMessage
                defaultMessage="Stats & Achievements - A new and improved experience that helps users log their adventures and celebrate their time outside. Trail-goers
              can track progress, earn badges, and view an inspiring snapshot of completed outdoor activities."
              />
            </li>
            <li>
              <FormattedMessage defaultMessage="National Park Guides - Curated guides for over 200 National Parks with tips on where to go, what to do, and how to be prepared." />
            </li>
            <li>
              <FormattedMessage
                defaultMessage="Improved on-trail navigation - An on-trail tool that allows users to follow a planned route, record an actual route, and easily find the
              way back to the point of origin."
              />
            </li>
          </ul>
          <br />
          <FormattedMessage
            defaultMessage="“AllTrails is honored to receive this recognition,” said Ivan Selin, Chief Product Officer at AllTrails. “It’s a testament to our commitment
          to designing innovative products that help people connect with the outdoors. We are excited to be able to positively impact people’s lives
          and look forward to bringing even more delightful experiences to our community in 2024. Stay tuned!”"
          />
          <br />
          <FormattedMessage
            defaultMessage="AllTrails continues to be the most recognized digital brand and category-leader in the outdoor activity sector. In addition to this recent
          recognition, AllTrails is frequently featured as a ‘Top 5 Health & Fitness App.’"
          />
          <br />
          <FormattedMessage defaultMessage="About AllTrails" />
          <br className={styles.noMargin} />
          <FormattedMessage
            defaultMessage="AllTrails helps you find your way outside with detailed reviews and inspiration from a global community of trail-goers. Every day, AllTrails
          is inspired to help get more people outside so they can have healthy, authentic experiences and a deeper appreciation of the outdoors."
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: (
      <FormattedMessage defaultMessage="AllTrails Marks World Mental Health Day By Sharing its ‘Nature Prescription’ to Optimize the Benefits of the Outdoors" />
    ),
    date: 'October 10, 2023',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Marks World Mental Health Day By Sharing its ‘Nature Prescription’ to Optimize the Benefits of the Outdoors" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the world’s leading outdoor exploration app, believes that nature is for everyone to enjoy, everyday - and especially on World Mental Health Day (October 10). However, as the Northern Hemisphere heads into winter, Seasonal Affective Disorder (SAD) - a mood disorder directly related to seasonal changes, can take a toll on mental and physical well-being. With many studies demonstrating that time spent outside can help improve overall health and mood, AllTrails wants to help make exploring nature a priority."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage defaultMessage="“The responsibilities of our daily lives, increased screen time, and generally spending most of our days indoors are all factors that can have a serious impact on our mental well-being and stress levels,” said Dr. Suzanne Hackenmiller, Chief Medical Advisor at AllTrails" />
          <br />
          <FormattedMessage defaultMessage="These stressors, compounded by shorter and colder days can make it increasingly difficult for people to get outside. Yet, studies prove that spending time outside can have a profound positive impact on our mental health. Some of these benefits include:" />
          <br />
          <ul>
            <li>
              <b>
                <FormattedMessage defaultMessage="Reduction in Stress:" />
              </b>{' '}
              <FormattedMessage
                defaultMessage="Spending time in natural settings, such as parks or forests, has been shown to reduce stress levels. Spending just 20-30 minutes in nature per day can significantly reduce cortisol, a hormone associated with stress. ({mentalHealthDaySource})"
                values={{
                  mentalHealthDaySource: mentalHealthDaySource(
                    'https://blog.frontiersin.org/2019/04/09/20-minute-nature-pill-relieves-stress/#:~:text=Nature%20will%20nurture&text=But%20if%20you%20spent%20a,but%20at%20a%20slower%20rate.'
                  )
                }}
              />
            </li>
            <li>
              <b>
                <FormattedMessage defaultMessage="Improved Mood:" />
              </b>{' '}
              <FormattedMessage
                defaultMessage="Exposure to natural light and green spaces can improve mood and reduce symptoms of depression. Even short walks in nature can lead to improvements in mood and well-being. ({mentalHealthDaySource})"
                values={{
                  mentalHealthDaySource: mentalHealthDaySource(
                    'https://www.psypost.org/2022/12/walking-in-nature-decreases-negative-feelings-among-those-diagnosed-with-major-depressive-disorder-64509'
                  )
                }}
              />
            </li>
            <li>
              <b>
                <FormattedMessage defaultMessage="Enhanced Cognitive Function:" />
              </b>{' '}
              <FormattedMessage
                defaultMessage="Being in nature can boost cognitive function and attention. Studies have shown that interacting with nature can improve attention and memory performance by as much as 20%. ({mentalHealthDaySource})"
                values={{
                  mentalHealthDaySource: mentalHealthDaySource('https://news.umich.edu/going-outsideeven-in-the-coldimproves-memory-attention/')
                }}
              />
            </li>
            <li>
              <b>
                <FormattedMessage defaultMessage="Benefits of Being Active:" />
              </b>{' '}
              <FormattedMessage
                defaultMessage="Hiking is a great physical activity. Just five minutes of exercise can stimulate anti-anxiety and anti-depression effects. According to the WHO, physical inactivity is a significant risk factor for mental health disorders. ({mentalHealthDaySource})"
                values={{
                  mentalHealthDaySource: mentalHealthDaySource(
                    'https://adaa.org/understanding-anxiety/related-illnesses/other-related-conditions/stress/physical-activity-reduces-st'
                  )
                }}
              />
            </li>
            <li>
              <b>
                <FormattedMessage defaultMessage="Social Interaction:" />
              </b>{' '}
              <FormattedMessage
                defaultMessage="Invite your friends to join you on your hike. Social interaction can combat feelings of loneliness and improve social well-being. Studies have shown group nature walks can lead to significant reductions in depression and perceived stress. ({mentalHealthDaySource})"
                values={{
                  mentalHealthDaySource: mentalHealthDaySource('https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3863862/')
                }}
              />
            </li>
            <li>
              <b>
                <FormattedMessage defaultMessage="Mindfulness and Relaxation:" />
              </b>{' '}
              <FormattedMessage
                defaultMessage="Studies have shown that natural settings can promote mindfulness and relaxation which are beneficial for mental health. ({mentalHealthDaySource})"
                values={{
                  mentalHealthDaySource: mentalHealthDaySource('https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6926748/')
                }}
              />
            </li>
          </ul>
          <br />
          <FormattedMessage
            defaultMessage="
            “Making conscious efforts to get outside, even during colder months, has been widely demonstrated to have significant benefits on both our
            physical and mental health, from boosting self esteem to aiding anxiety and depression,” she added.
          "
          />
          <br />
          <FormattedMessage
            defaultMessage="In fact, it’s been proven that when people experiencing symptoms of SAD implemented a daily morning walk outside, depression scores decreased by 50 percent after a week of one-hour walks and exposure to natural light. ({mentalHealthDaySource})"
            values={{
              mentalHealthDaySource: mentalHealthDaySource('https://www.sciencedirect.com/science/article/abs/pii/016503279500081X?via%3Dihub')
            }}
          />
          <br />
          <FormattedMessage defaultMessage="To mark World Mental Health Day, Dr. Hackenmiller is sharing her top tips for making ‘nature prescriptions’ part of your self care routine:" />
          <br />
          <ul>
            <li>
              <b>
                <FormattedMessage defaultMessage="Find an accountability buddy:" />
              </b>{' '}
              <FormattedMessage defaultMessage="If you find it difficult to escape your day to day stressors, let a friend or family member know about your intentions to get outside more and ask them to help you stay accountable. You may find they join you!" />
            </li>

            <li>
              <b>
                <FormattedMessage defaultMessage="‘Some’ is better than none:" />
              </b>{' '}
              <FormattedMessage
                defaultMessage="Studies have shown that we experience a positive improvement in our mood within the first five minutes of being outside. Try taking the long route to your local cafe for your morning coffee or think about spending your lunch break outside. The AllTrails app can point you to top trails and alternative routes nearby, no matter where you are. ({mentalHealthDaySource})"
                values={{
                  mentalHealthDaySource: mentalHealthDaySource('https://www.tandfonline.com/doi/abs/10.1080/17439760.2018.1557242')
                }}
              />
            </li>

            <li>
              <b>
                <FormattedMessage defaultMessage="Seize the Day (or Night): " />
              </b>{' '}
              <FormattedMessage
                defaultMessage="If your mornings are busy, don’t force a walk into your schedule. You can still gain all the health benefits of being in nature at sunset and can often find quieter trails unfolding under a limitless night sky. ({mentalHealthDaySource1}). Better yet, grab a friend or family member for a nighttime walk, as exposing yourself to the dark naturally releases melatonin to aid in a better night’s rest. ({mentalHealthDaySource2})"
                values={{
                  mentalHealthDaySource1: mentalHealthDaySource('https://journals.co.za/doi/abs/10.10520/ejc-menhm_v9_n4_a9'),
                  mentalHealthDaySource2: mentalHealthDaySource(
                    'https://www.sleepfoundation.org/bedroom-environment/light-and-sleep#:~:text=Melatonin%20is%20a%20hormone%20that,slows%20or%20halts%20that%20production.'
                  )
                }}
              />
            </li>
          </ul>
          <br />
          <FormattedMessage
            defaultMessage="
            With over 400,000 trails available to explore globally on the AllTrails app, making nature a permanent part of your self care routine has
            never been easier.
          "
          />
          <br />
          <FormattedMessage defaultMessage="See you outside!" />
        </Typography>
      </>
    )
  },

  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Announces Google Watch Integration" />,
    date: 'October 4, 2023',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Announces Google Watch Integration" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="AllTrails users can explore hands-free with Wear OS by Google" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the world’s largest and most trusted outdoor platform, has launched an integration with Wear OS by Google that allows users to track activities directly on their smart watch screens. The integration makes it even easier for people to take AllTrails along as they discover the outdoors."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage defaultMessage="The new integration will help trail-goers seamlessly explore and track their outdoor adventures. Integration functionality includes:" />
          <br />
          <span>
            <ul>
              <li>
                <FormattedMessage defaultMessage="Tracking activity progress along a route." />
              </li>
              <li>
                <FormattedMessage defaultMessage="Viewing stats and achievements." />{' '}
              </li>
              <li>
                <FormattedMessage defaultMessage="Receiving alerts." />
              </li>
              <li>
                <FormattedMessage defaultMessage="Ability to pause and resume route recordings." />
              </li>
              <li>
                <FormattedMessage defaultMessage="Viewing estimated mileage remaining on a planned route." />
              </li>
            </ul>
          </span>
          <br />
          <FormattedMessage defaultMessage="The Wear OS-integrated AllTrails experience is available internationally to both AllTrails and AllTrails+ members." />
          <br />
          <FormattedMessage defaultMessage="“At AllTrails, we’re committed to helping people discover, record, and share their outdoor experiences,” said Ron Schneidermann, CEO of AllTrails. “Together, with Wear OS by Google, we’re excited to bring everyone one more way to explore the outdoors, hands-free.”" />
          <br />
          <FormattedMessage defaultMessage="To download and use the AllTrails Wear OS watch app, users can visit Google Play." />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Announces Updated and Improved Stats & Achievements" />,
    date: 'September 14, 2023',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Announces Updated and Improved Stats & Achievements" />
        </Typography>

        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="AllTrails’ new Stats & Achievements help trail-goers celebrate their time outside" />
        </Typography>

        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the world’s largest and most trusted outdoor platform, today launched new Stats & Achievements, a personalized experience that helps users log adventures and celebrate their time outside. The feature set gives trail-goers an inspiring snapshot of their outdoor activities and is part of a suite of benefits that AllTrails offers for exceptional outdoor experiences."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage defaultMessage="After recording an activity using AllTrails’ Navigate feature, users will see their activities logged and Achievements earned in their profile. With five different Achievements to unlock–longest activity, longest streak, most time outside, highest point, and most elevation gain–AllTrails members can track and share their outdoor accomplishments. With  Stats, users can keep track of  their total distance, elevation gain, completed activities, and moving time over the course of  the prior month, prior year, and all time." />
          <br />
          <FormattedMessage defaultMessage="“We all love the feelings of joy and satisfaction when reaching a summit, and we wanted to capture that with our all-new Stats experience,” explains Ron Schneidermann, CEO of AllTrails. “AllTrails members log inspiring outdoor activities. Now they can celebrate those trail experiences and share their accomplishments. We hope the AllTrails community will be even more eager to get outside and celebrate their adventures on the trail.”" />
          <br />
          <FormattedMessage
            defaultMessage="AllTrails' new Stats experience, featuring new Achievements, is accessible via every user’s profile on the mobile app and at {alltrailsDotComLink}. To start tracking personalized stats and earning achievement badges, use Navigate so that all activities are stored and saved in the user profile."
            values={{ alltrailsDotComLink }}
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Launches Informative and Inspirational National Parks Guides" />,
    date: 'September 8, 2023',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Launches Informative and Inspirational National Parks Guides" />
        </Typography>

        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="Comprehensive planning and on-trail toolkit expertly curated for more than 200 of the world’s most beloved parks, are now available to the AllTrails+ community" />
        </Typography>

        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the world’s largest and most trusted outdoor platform, today announced the launch of “Guides”, a collection of expertly curated National Park and outdoor content. Available to every AllTrails+ member, the National Park Guides include trail recommendations and essential information such as park fees, reservations, and seasonal experiences–all in one place. With more than 400,000 trails around the world reviewed by the AllTrails community of more than 55 million explorers, National Parks Guides further expands AllTrails’ leading and authoritative outdoor resources."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage defaultMessage="AllTrails’ new National Parks Guides are now available for more than 200 parks, covering eight countries including Australia, Canada, England, Ireland, New Zealand, Scotland, The United States and Wales. From top trails to hidden gems, Guides is the digital ticket trail-goers need to plan and prepare for an unrivaled National Parks experience." />
          <br />
          <FormattedMessage defaultMessage="“National Parks are our most cherished and visited outdoors spaces; our Guides deliver inspired content and comprehensive insights that are certain to enhance the National Park experience,” explains Ron Schneidermann, CEO of AllTrails. “From America’s Yosemite Valley to The Blue Mountains in Australia, these Guides deliver exceptional discovery and exploration resources for more than 200 parks.”" />
          <br />
          <FormattedMessage
            defaultMessage="AllTrails+ Guides will continue to expand to more countries and parks in the coming months. The Guides are available to AllTrails+ members in the AllTrails app and online at {alltrailsLink}."
            values={{ alltrailsLink }}
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Shares Top Trail ‘Petiquette’ Tips For Hitting The Trails on Global Dog Day" />,
    date: 'August 23, 2023',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Shares Top Trail ‘Petiquette’ Tips For Hitting The Trails on Global Dog Day" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage defaultMessage="AllTrails, the world’s leading outdoor exploration app, knows that hiking companions come in all forms - partners, neighbors, siblings, and of course, furry four-legged friends. Whether you’re exploring one of AllTrails’ 400,000+ trails in your own neighborhood, or venturing to new heights and horizons, AllTrails believes that like most things, trails are better with dogs." />
          <br />
          <FormattedMessage defaultMessage="Ahead of Global Dog Day (August 26th), AllTrails is sharing its Top Trail ‘Petiquette’ Tips to keep in mind as you hit the trails with your loyal companion." />
          <br />
          <ul>
            <li>
              <b>
                <FormattedMessage defaultMessage="Only visit dog-friendly trails" />
              </b>
              <FormattedMessage defaultMessage=". Sticking to dog-approved paths protects environmentally sensitive areas and also ensures people who prefer to hike in a dog-free zone have the opportunity. Before you head out, you can easily locate the best dog-friendly trail near you via the AllTrails app under the “Suitability” filter. " />
            </li>
            <li>
              <b>
                <FormattedMessage defaultMessage="Follow leash laws" />
              </b>
              <FormattedMessage defaultMessage=". Even if your dog is comfortable without a leash, leash laws make for a safer experience for everyone and ensure your dog doesn’t run off the trail into any potential danger. Check local leash laws and look for signs near the trail to confirm if trails require dogs to be on leash. Many of the more popular dog-friendly trails on AllTrails will note leash laws in the description." />
            </li>

            <li>
              <b>
                <FormattedMessage defaultMessage="Clean up after your dog" />
              </b>
              <FormattedMessage
                defaultMessage=". Just as humans are expected to {leaveNoTraceLink}, so are dogs! One way to ruin a beautiful trail is to leave behind a poop bag. It is the responsibility of the owner to pick up after your dog and keep trails as clean as you found them. "
                values={{ leaveNoTraceLink }}
              />
            </li>
            <li>
              <b>
                <FormattedMessage defaultMessage="Yield to oncoming traffic" />
              </b>
              <FormattedMessage defaultMessage=". While a dog on the horizon may be a great vision for you, many people can be nervous around dogs. Be considerate and give the passersby plenty of space to get around you and your dog so they can comfortably navigate trails." />
            </li>
            <li>
              <b>
                <FormattedMessage defaultMessage="Prep your pup" />
              </b>
              <FormattedMessage defaultMessage=". Before taking to the outdoors with your dog, invest in the necessary gear to ensure an enjoyable and safe outing. Always pack a sturdy collar or harness and leash, dog waste bags, treats, and enough water for the both of you. Depending on the area, consider tick and flea prevention along with paw protectors when taking to unknown trails." />
            </li>
          </ul>

          <br />
          <FormattedMessage
            defaultMessage="To inspire people to get outside with their pup on Global Dog Day and beyond, AllTrails has teamed up with leading pet retailer {petSmartLink} to offer existing {plusLink} members in the U.S. and Canada $10 off purchases of $60 and up online when paired with a Treats Rewards membership. Pet parents can outfit their dog with all the gear needed for an outdoor adventure, or stock up on treats for a post-hike snack. "
            values={{ petSmartLink, plusLink }}
          />
          <br />
          <FormattedMessage defaultMessage="See you (and your furry friends) on the trail!" />
          <br />
          <em>
            <FormattedMessage
              defaultMessage="*Offer valid one time only 8/26/2023 – 9/5/2023 online at PetSmart.com, PetSmart.ca or the PetSmart app with Treats membership. Sign-up
            for Treats Rewards or sign-in to your Treats Rewards account prior to purchase. Enter promo code at check-out to receive discount. Max
            savings $10.00. Transaction total is prior to taxes & after discounts are applied. Treats rules apply. See petsmart.com/treats. Treats
            members get free shipping on select orders over $49, prior to taxes and after discounts. Products & services are subject to availability.
            Prices & selection may vary in stores & online. Pet age, health & vaccination requirements apply for services. At the sole discretion of
            PetSmart, some pets may not be permitted. Breed restrictions may apply."
            />
          </em>
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Unveils New Updates for Better Summer Adventures" />,
    date: 'July 1, 2023',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Unveils New Updates for Better Summer Adventures" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage defaultMessage="AllTrails, the definitive digital trail app, announced a portfolio of new product features, adding new ways to inspire people to get outside, and making it easier than ever to explore the outdoors. With its more than 400,000 trails around the world and its comprehensive planning and on-trail toolkit, AllTrails continues to innovate." />
          <br />
          <FormattedMessage defaultMessage="Inspired by user needs and requests, AllTrails’ expanded capabilities offer new ways for users to discover, prepare, navigate, and track their outdoor experiences. Learn more about AllTrails newest features and check them out for yourself in the AllTrails app:" />
          <br />
          <li>
            <b>
              <FormattedMessage defaultMessage="Local Community Feed" />
            </b>
            <FormattedMessage defaultMessage=": Get inspired by others’ trail activities near you or at your travel destination. Browse the new Community feed to explore like a local and check out recent trail activity in any location - near or far. Plus, easily adjust your privacy settings to control who sees the routes you choose to navigate." />
          </li>
          <li>
            <b>
              <FormattedMessage defaultMessage="Garmin Courses" />
            </b>
            <FormattedMessage defaultMessage=": Now you can upload any route from AllTrails to your Garmin device. AllTrails’ direct integration allows you to send a custom route you've created on AllTrails or a verified trail route from AllTrails to your Garmin device so you can follow the route hands-free. Available with AllTrails+." />
          </li>
          <li>
            <b>
              <FormattedMessage defaultMessage="Advanced Conditions" />
            </b>
            <FormattedMessage defaultMessage=": Know what to expect before you head out, with information on temperature, trail conditions, and mosquito activity along the trail. AllTrails’ new Advanced Conditions helps you know what to expect, and be prepared with the right clothing and footwear. Head to the Trail Page to view Advanced Conditions, available with AllTrails+." />
          </li>
          <li>
            <b>
              <FormattedMessage defaultMessage="Log Your Adventures" />
            </b>
            <FormattedMessage defaultMessage=": Now you can view your trail activities, stats, photos, and reviews all in one place. AllTrails’ updated profile page helps you keep track of all of your adventures and your total mileage, elevation, and more." />
          </li>
          <li>
            <b>
              <FormattedMessage defaultMessage="View Immersive Trail Previews" />
            </b>
            <FormattedMessage defaultMessage=": An interactive video allows you to get a whole new perspective of the trail so you know what to expect. Check out any trail, and click “Preview Trail” to get a feel for the elevation and terrain and determine which trail you want to explore." />
          </li>
          <br />
          <FormattedMessage defaultMessage="AllTrails’ ongoing product innovation continues to solidify its role as the world’s leading outdoor exploration app - serving more than 50 million trail goers around the world." />
          <br />
          <FormattedMessage defaultMessage="See you on the trail!" />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Unveils New Brand Identity to Reflect a More Inclusive & Connected Outdoor Community" />,
    date: 'January 25, 2023',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Unveils New Brand Identity to Reflect a More Inclusive & Connected Outdoor Community" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="‘The Outside in All of Us’ dispels the myth that the outdoors is only meant for the ‘outdoorsy’" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink},  the definitive digital trail expert and your companion to the outdoors, is kicking off the year by
            unveiling a new brand identity - ‘The Outside in All of Us’ - inviting everyone, regardless of expertise or background, to get outside."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="AllTrails’ refreshed brand identity was inspired by the company’s belief that the outside isn’t a place to seek,
          but rather a part of each and every one of us. Design elements evoke the beauty and diversity of global outdoor landscapes, activities, and communities."
          />
          <br />
          <FormattedMessage defaultMessage="As part of the brand’s refresh, AllTrails is launching:" />
          <br />
          <li>
            <b>
              <FormattedMessage defaultMessage="A refreshed visual identity" />
            </b>
            <FormattedMessage defaultMessage=", including a new symbol, wordmark, typography, graphic elements, art direction and color palette" />
          </li>
          <li>
            <b>
              <FormattedMessage defaultMessage="New tone and messaging" />
            </b>
            <FormattedMessage defaultMessage=", invoking the persona of your adventurous friend; inspiring, motivating, adventurous, trustworthy, and never intimidating" />
          </li>
          <li>
            <b>
              <FormattedMessage defaultMessage="Rebranded premium offering “AllTrails Pro” to “AllTrails+”" />
            </b>
            <FormattedMessage defaultMessage="making it clear that AllTrails+ isn’t about who scales the highest mountains – it’s about giving everyone extra tools to save time, be prepared, and do more outdoors." />
          </li>
          <br />
          <FormattedMessage
            defaultMessage="“We’re building a movement to redefine the outdoors, remove hurdles in the path, and help everyone find a sense of belonging in the outdoors” said Carly Smith Costello, CMO of AllTrails.
          “The time has come to reflect this in our brand. We’re re-introducing ourselves with an inviting  brand identity - a fresh new look and feel and a new brand for our premium offering,” she added."
          />
          <br />
          <FormattedMessage
            defaultMessage="The brand evolution is now live in the AllTrails app and at {alltrailsLink}."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="In addition to the new branding, AllTrails has also expanded its Community feature, building a space for the brand’s over 45 million users to connect and inspire one another.
          The community feature helps users explore and discover even more trails and outdoor spaces, all through a user’s network of connections."
          />
          <br />
          <FormattedMessage defaultMessage="All of these Community features are available to members today, completely free of charge." />
          <br />
          <FormattedMessage
            defaultMessage="As the definitive digital trail expert and content provider, the new AllTrails branding and evolved product experience are among a few of the ways the company is living out its mission
          to kindle the spirit of adventure as the world’s largest, most inclusive outdoor community. Currently, the platform is home to:"
          />
          <br />
          <li>
            <FormattedMessage defaultMessage="45 million trail-goers" />
          </li>
          <li>
            <FormattedMessage defaultMessage="400K+ curated trails" />
          </li>
          <li>
            <FormattedMessage defaultMessage="700+ million logged miles" />
          </li>
          <br />
          <FormattedMessage
            defaultMessage="With AllTrails, users can plan, live, and share adventures, be it a mountain trek or a stroll in the park. The AllTrails app boasts trail coverage on all seven continents
          and every country, making it the most recognized digital brand and category-leader in the outdoor activity sector."
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Grows Global Outdoors Platform with Launch of 10 New Languages" />,
    date: 'November 1, 2022',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Grows Global Outdoors Platform with Launch of 10 New Languages" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="With 14 languages now available, AllTrails delivers trail mapping app to millions more users, expanding access to the outdoors" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the most trusted and used outdoors platform, today announced the launch of 10 new languages on its global trail app and website. With this expansion,
            AllTrails is now available in 14 languages, significantly widening the opportunity for the platform’s community of more than 40 million outdoor enthusiasts and 350,000 hiking, running,
            and mountain biking trails worldwide."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="The 10 new languages include Danish, Dutch, British English, Italian, Norwegian, Portuguese, Brazilian Portuguese, Polish, Latin American Spanish, and Swedish.
          These languages add to the four existing languages of American English, French, German, and Spanish. The expansion will contribute to growing the AllTrails global community and make the app easier to use
          around the globe. Across the regions that recognize these as official languages, there are more than 87,500 hand-curated trails for hikers, bikers, walkers, and runners."
          />
          <br />
          <FormattedMessage
            defaultMessage="“The launch of 10 new languages marks an important milestone for the global growth of the AllTrails community,” said Ron Schneidermann, CEO, AllTrails. “These languages are representative
          of many of the most active outdoors communities and diverse trail locations; this expansion will only improve users’ experience on our platform. The AllTrails community is at the core of what makes AllTrails such a powerful resource.
          Launching new languages is another step toward our mission to make the outdoors more accessible to everyone.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="The AllTrails platform helps users find and explore new trails, connect to routes best suited for their unique needs, and get outdoors with the peace of mind provided by navigation tools, as well as
          reviews and photos from other AllTrails users. With AllTrails, people of all skill levels can discover, record, and share their outdoor experiences. The AllTrails app boasts trail coverage on all seven continents and every country,
          making it the most recognized digital brand and category-leader in the outdoor activity sector."
          />
          <br />
          <FormattedMessage defaultMessage="The new languages expansion reach many more communities including the following locations and trails:" />
          <br />
          <ul>
            <li>
              <FormattedMessage defaultMessage="Denmark: 5,338 trails" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Netherlands: 6,370 trails" />
            </li>
            <li>
              <FormattedMessage defaultMessage="United Kingdom: 25,369 trails" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Poland: 3,156 trails" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Italy: 11,850 trails" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Sweden: 5,075 trails" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Norway: 6,339 trails" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Portugal: 4,133 trails" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Brazil: 8,222 trails" />
            </li>
            <li>
              <FormattedMessage defaultMessage="Latin America: 11,693 trails" />
              <ul>
                <li>
                  <FormattedMessage defaultMessage="Argentina: 1,290" />
                </li>
                <li>
                  <FormattedMessage defaultMessage="Chile: 1,607" />
                </li>
                <li>
                  <FormattedMessage defaultMessage="Mexico: 6,262" />
                </li>
                <li>
                  <FormattedMessage defaultMessage="Peru: 1,200" />
                </li>
              </ul>
            </li>
          </ul>
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Expands Features Offering, Helping Connect More People to the Outdoors" />,
    date: 'October 01, 2022',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Expands Features Offering, Helping Connect More People to the Outdoors" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="New Features Further Improve App Experience and Provide Peace of Mind for Trail-Goers" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the most trusted and used global outdoors platform, today announced several additions to its current suite of features.
            These additions benefit the brand’s global community by helping them prepare for unique and ever-changing trail conditions, stay safe, and save time before
            heading outside. With these additions, AllTrails aims to remove barriers to venturing outdoors, and to help its community of more than 40 million outdoor enthusiasts
            explore its over 350,000 trails with even greater ease."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage defaultMessage="Inspired by both user feedback and requests, AllTrails is adding five new features to its PRO and Free platforms. These features include:" />
          <br />
          <b>
            <FormattedMessage defaultMessage="AllTrails PRO" />
          </b>
          <li>
            <FormattedMessage
              defaultMessage="Distance Away: This feature addresses what consumers cite as their single largest barrier to getting outside - time. Distance away helps users find nearby
              trails by filtering for routes within a specified distance of their location. Users can find trails that help them maximize their time outside - spending less time driving and more time on the trail."
            />
          </li>
          <li>
            <FormattedMessage
              defaultMessage="3D Maps: The newest AllTrails PRO feature, 3D Maps provides the user a sense of the trail experience before ever stepping foot outside. The
              feature shows the trail's terrain and elevation to help users know what to expect before hitting the trail."
            />
          </li>
          <br />
          <b>
            <FormattedMessage defaultMessage="AllTrails" />
          </b>
          <li>
            <FormattedMessage
              defaultMessage="Recent Trail Conditions: This new feature is powered by our global community of users, who give insight to whether trails were
              recently muddy, slippery, icy, buggy, or snowy. This information gives users information to plan ahead, and make informed decisions on how
              to prepare, dress, and what gear to bring."
            />
          </li>
          <li>
            <FormattedMessage
              defaultMessage="Estimated Time Remaining: Also inspired by user-requests, this feature eliminates guesswork by helping trail-goers understand how much time
              is left to complete the trail."
            />
          </li>
          <li>
            <FormattedMessage
              defaultMessage="Language Expansion: The AllTrails app and web experience is now also available in 10 new languages/dialects (14 total) including: British
              English, Danish, Dutch, Italian, Norwegian, Polish, Swedish, Portuguese, Brazilian Portuguese, and Latin American Spanish."
            />
          </li>
          <br />
          <FormattedMessage
            defaultMessage="These features are in addition to the platform’s original host of PRO offerings that help keep its community safe and informed while on the
          trail. These include:"
          />
          <br />
          <b>
            <FormattedMessage defaultMessage="AllTrails PRO" />
          </b>
          <li>
            <FormattedMessage defaultMessage="Offline Maps: Users can download maps ahead of time to help stay on track, even without cell service or when reception is lost." />
          </li>
          <li>
            <FormattedMessage defaultMessage="Off-Route Alerts: In the event of a wrong turn, users receive a notification to help quickly course-correct and get back on the right path." />
          </li>
          <li>
            <FormattedMessage defaultMessage="Printed Maps: Unplug completely, and print maps directly from AllTrails or as a backup to technology." />
          </li>
          <br />
          <FormattedMessage
            defaultMessage="The expansion will enhance both the users’ in-app and on-trail experience, helping walkers, bikers, hikers, and runners plan ahead, prepare,
          save time, and stay safe while enjoying the outdoors."
          />
          <br />
          <FormattedMessage
            defaultMessage="“As the most trusted digital guide to the outdoors, we have a responsibility to ensure our global community is safe, prepared, and has a fun
            experience when getting outdoors,” said Ron Schneidermann, CEO of AllTrails. We’ve listened to our users, absorbed their feedback, and are
            thrilled to add five new features that are inspired by their wants and needs. Our goal is to help people of all abilities, levels of
            expertise, and in all corners of the world access the outdoors,” he added."
          />
          <br />
          <FormattedMessage
            defaultMessage="The AllTrails platform helps users find and explore new trails, connect to routes best suited for their unique needs, and get outdoors with
            the peace of mind provided by navigation tools, as well as reviews and photos from other AllTrails users. With AllTrails, people of all
            skill levels can discover, record, and share their outdoor experiences. The AllTrails app boasts trail coverage on all seven continents and
            every country, making it the most recognized digital brand and category-leader in the outdoor activity sector."
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Celebrates 1 Million Paid Subscribers" />,
    date: 'Jan 26, 2021',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Celebrates 1 Million Paid Subscribers" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="Milestone Cements the Brand's Vision to Democratize Access to the Outdoors For All" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the most trusted and used digital guide to the outdoors announced a substantial
            milestone - surpassing 1 million paid subscribers for its premium service, AllTrails Pro. Home to the largest collection of hand-curated
            trail guides, the outdoor recreation website and app also maintains a global community of over 25 million registered users. "
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="Even prior to the pandemic, the outdoor sector was experiencing rapid year-over-year growth as more people turned to nature for mental and
            physical health. By May 2020, when pandemic lockdowns loosened, AllTrails saw an accelerated surge of usage as people reconnected with the
            outdoors. The company saw record-breaking growth continue through December, a contrast to the seasonal growth that is typical in the outdoor
            industry. While habit changes during the pandemic further accelerated business performance, the behavior also underscores the impact nature
            has on mental and physical health."
          />
          <br />
          <FormattedMessage
            defaultMessage="“At AllTrails, we believe that everyone has a right to the outdoors, regardless of age, gender, ethnicity, or socioeconomic standing,” said
            Ron Schneidermann, CEO of AllTrails. “Our public lands are for everyone to enjoy and to experience the mental, physical, and emotional
            health benefits that come from spending time outside. This level of growth confirms that we are on the right path in leveraging technology
            to democratize access to the outdoors for all.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="To commemorate the milestone, AllTrails, a 1% For The Planet member, is partnering with One Tree Planted to plant 10 thousand trees - one
            thousand trees for each year AllTrails has served its global community of outdoor enthusiasts."
          />
          <br />
          <FormattedMessage
            defaultMessage="“AllTrails' breakout growth is representative of a larger trend of people adopting new lifestyles and looking to the outdoors,” said Ben
            Spero, managing director at Spectrum Equity, a growth equity firm that is AllTrails' majority shareholder. “It's a rare accomplishment for a
            consumer subscription service to reach 1 million paid subscribers, and this milestone is a testament to the unique service AllTrails
            provides its community in helping connect them to the outdoors and to nature,” he added."
          />
          <br />
          <FormattedMessage defaultMessage="In the past year, AllTrails has achieved:" />
          <br />
          <li>
            <FormattedMessage defaultMessage="One million AllTrails Pro subscribers" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Over 25 million cumulative registered users" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Nearly 130% year-over-year increase in daily active users" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Publishing of nearly 200 thousand trail guides" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Trail coverage in 190 countries, 30 territories, and all 7 continents" />
          </li>
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Offers Best Practices for Getting Outside Responsibly" />,
    date: 'May 07, 2020',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Offers Best Practices for Getting Outside Responsibly" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="With parks reopening, the outdoor recreation app shares how to hit the trail for mental and physical health, even while social distancing" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="As coronavirus restrictions loosen, {alltrailsLink}, the most trusted and used digital guide to the
            outdoors, is sharing ways people can safely get outside for mental and physical health."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="“There's a lot to adjust to in this new normal, but what hasn't changed are the mental and physical health benefits that we can all achieve
          by simply spending time in nature,” said Ron Schneidermann, CEO of AllTrails. “As a company, we're committed to encouraging everyone that
          time spent outside is an easily accessible yet powerful catalyst for healthy and resilient communities.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="In partnership with its board of medical advisors, AllTrails notes that the following are ways that people can responsibly get outdoors for
          mental and physical health:"
          />
          <br />
          <li>
            <FormattedMessage
              defaultMessage="Practice social distancing guidelines when on the trail. Walk single file to avoid overcrowding the path and keep moving to avoid
            unintentional bottlenecks."
            />
          </li>
          <li>
            <FormattedMessage defaultMessage="Bring a mask or bandana, even if it means only wearing it when passing others." />
          </li>
          <li>
            <FormattedMessage defaultMessage="To limit the spread of the virus, opt for outings on local trails rather than traveling to popular outdoor recreation destinations." />
          </li>
          <li>
            <FormattedMessage
              defaultMessage="Avoid trailheads with extensive parking lots, as these can attract large groups. If parking lots are full, consider exploring another
            trail."
            />
          </li>
          <li>
            <FormattedMessage
              defaultMessage="AllTrails data indicates that trail activity is busiest on the weekends during the late morning and early afternoon. Plan activities
              during quieter hours, such as on weekday mornings."
            />
          </li>
          <br />
          <FormattedMessage defaultMessage="The AllTrails app also has several features that promote responsible social distancing outdoors:" />
          <br />
          <li>
            <FormattedMessage defaultMessage="The trail traffic filter helps users identify trails that are less congested." />
          </li>
          <li>
            <FormattedMessage defaultMessage="The route-type filter locates loops, rather than out-and-back routes, for less contact with other trail-goers." />
          </li>
          <li>
            <FormattedMessage
              defaultMessage="The app also details trail length and difficulty. If users are capable and up for the challenge, harder and longer routes tend to be less
            crowded, particularly as the trail veers further from the trailhead."
            />
          </li>
          <br />
          <FormattedMessage
            defaultMessage="As a champion of the mental and physical health benefits of the outdoors, AllTrails is committed to empowering people with the confidence to
              hit the trail safely and responsibly during this unprecedented time."
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails® Acquires Trails.com" />,
    date: 'Jul 18, 2019',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails® Acquires Trails.com" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="Purchase Marks the Third Acquisition by AllTrails, the Most Comprehensive Global Digital Outdoors Guide Provider" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the most trusted and used digital guide to the outdoors, announced today the
            acquisition of pioneering platform for outdoor recreation, Trails.com. Terms of the transaction were not disclosed."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="Trails.com provides maps and tips for activities such as hiking, mountain biking, snowshoeing and trail running, assisting trail-goers with
          navigation for outdoor adventures. “We are thrilled to join AllTrails in its effort to equip outdoor enthusiasts with even more content,
          help people get outside and enjoy nature,” said Howard Love, CEO of LoveToKnow, Corp, Trails.com's holding company. Trails.com is AllTrails'
          third acquisition and strengthens its growing library of over 75 thousand hand curated trail maps."
          />
          <br />
          <FormattedMessage
            defaultMessage="“At AllTrails, we are committed to helping people all over the world, in both urban and rural communities, get outside, and see all that
          nature has to offer,” said Jade Van Doren, CEO of AllTrails. “Whether it's a quick stroll to help decompress or a backpacking adventure
          through the wilderness, we want to make the outdoors safer and more accessible for all. This acquisition helps us serve even more people in
          their quest to enjoy the outdoors.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="Trails.com is AllTrails' second acquisition of 2019. AllTrails acquired UK based trails app, iFootpath, in April 2019, and EveryTrail in
          2016. The company also recently received a $75 million investment from Spectrum Equity in October 2018 to help grow its overseas presence
          and expand trail data."
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Acquires iFootpath" />,
    date: 'Apr 24, 2019',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Acquires iFootpath" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="Acquisition Makes AllTrails the Most Comprehensive Global Digital Outdoors Guide Provider" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the most trusted and used digital guide to the outdoors, announced today the
            acquisition of iFootpath, the #1 paid travel app in the UK. Terms of the transaction were not disclosed. "
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="“iFootpath's mission is to make walking in the UK fun, accessible and stress-free,” explained Claire Sharp and Richard Jemmett, Co-Founders
          of iFootpath. “We're excited to be working with AllTrails to make our walking guides available to an even wider audience.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="Since its founding in 2011, iFootpath has published over 1300 hand-curated guides focusing on walking trails in the UK. Each guide includes
          a detailed map along with turn-by-turn directions, waypoints, photos, and driving directions to the trailhead."
          />
          <br />
          <FormattedMessage
            defaultMessage="“Our mission is to help people all over the world spend more time enjoying the outdoors,” explained Jade Van Doren, CEO of AllTrails. “By
          adding iFootpath's extensive data to the AllTrails platform, we have made it easier than ever for both locals and tourists to explore all
          that the United Kingdom has to offer.”"
          />
          <br />
          <FormattedMessage defaultMessage="iFootpath is AllTrails' second acquisition, following EveryTrail in 2016." />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="Spectrum Equity Leads New Investment and Majority Recapitalization of AllTrails" />,
    date: 'Oct 11, 2018',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="Spectrum Equity Leads New Investment and Majority Recapitalization of AllTrails" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="Investment will foster continued growth of global digital outdoors guide provider" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{spectrumEquityLink} announced that it led a substantial new investment in AllTrails, the most trusted and used digital guide to the outdoors, to help accelerate
            product development, add more trail content around the world and grow the company's user base. As part of the transaction, Spectrum acquired
            a majority stake in AllTrails, in partnership with the company's CEO Jade Van Doren, and COO Ron Schneidermann. "
            values={{ spectrumEquityLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="AllTrails helps over 9 million registered users discover, record and share their outdoor experiences, including hiking, mountain biking and
          trail running. AllTrails has created the largest collection of trail information globally with over 55,000 hand-curated trails in 102
          different countries. The company has grown rapidly over the past few years without significant outside funding."
          />
          <br />
          <FormattedMessage defaultMessage="In conjunction with the transaction, Ben Spero and Matt Neidlinger from Spectrum Equity will join the board of directors." />
          <br />
          <FormattedMessage
            defaultMessage="“We are thrilled to partner with Jade, Ron and the entire AllTrails team to support the company in its next phase of growth,” said Ben
          Spero, Managing Director of Spectrum Equity. “The company is helping millions of people discover great outdoor activities and lead
          healthier, active lifestyles.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="“Spectrum's extensive experience with freemium, subscription-based businesses was particularly attractive to us in considering potential
          financial partners,” said Jade Van Doren, CEO of AllTrails. “We're thrilled to have Spectrum as our new partner as we continue to innovate
          on our products, expand our trail coverage around the world and support our passionate community of users.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="Matt Neidlinger from Spectrum Equity added, “As we've gotten to know Jade, Ron and the team over the past few years, we've been impressed by
          their ability to scale the platform into the most-recognized, category-leading brand in the space.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="AllTrails was advised by Stubbs Alderton & Markiles with GP Bullhound serving as AllTrails' exclusive financial advisor. Spectrum Equity was
          advised by Latham & Watkins."
          />
          <br />
          <FormattedMessage defaultMessage="Financial terms of the transaction were not disclosed." />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails® Acquires German Trails App GPSies" />,
    date: 'Jul 30, 2019',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails® Acquires German Trails App GPSies" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="Purchase Solidifies Brand's Global Presence and Expands European Trail Network" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the most trusted and used digital guide to the outdoors, announced today the
            acquisition of German-based outdoor recreation platform, GPSies. The deal further enhances AllTrails' trail coverage across Europe and
            cements its position as the most comprehensive global resource for outdoor recreation. "
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="Since its founding in 2006, GPSies has helped hikers, walkers and cyclists across the EU plan outdoor activities with a robust library of
          user generated GPS recordings along with a powerful route planning tool for creating downloadable custom maps. “We are delighted to join
          AllTrails in our mutual goal of helping people embrace the outdoors,” said Klaus Bechtold, CEO of GPSies. “Together we can bring even more
          routes, services and information to a growing audience of people who are looking to spend more time outside enjoying nature.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="As part of the company's effort to better serve trail-goers across the globe, AllTrails recently launched translated versions of its mobile
          apps and website, making all of its content available in German, French, and Spanish."
          />
          <br />
          <FormattedMessage
            defaultMessage="“Time spent in the outdoors is beneficial for everyone, improving both our physical and mental well being,” said Jade Van Doren, CEO of
          AllTrails. “By continuing to expand our presence in Europe, we are not only fulfilling our goal of helping people access nature more easily
          and safely, but also making a positive impact on people's health.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="GPSies is AllTrails' fourth acquisition; the company most recently acquired Trails.com in July 2019, UK based trails app iFootpath in April
          2019, and EveryTrail in 2016. The company also recently received a $75 million investment from Spectrum Equity in October 2018 to help grow
          its overseas presence and expand trail data."
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Gives Trail Users Peace of Mind With Launch of Lifeline" />,
    date: 'Aug 28, 2018',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage defaultMessage="AllTrails Gives Trail Users Peace of Mind With Launch of Lifeline" />
        </Typography>
        <Typography variant="heading200" component="h3">
          <FormattedMessage defaultMessage="Live Location Tracking Feature Keeps Loved Ones Informed" />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the most trusted and used digital guide to the outdoors, today announced the
            release of a new feature called Lifeline to its number one-rated mobile app for iOS and Android. Designed to put outdoor enthusiasts and
            their loved ones at ease, AllTrails Pro subscribers can now provide designated safety contacts with a detailed map of their planned route,
            status updates and automated emergency alerts while out on the trail. If the user's phone has a data connection, safety contacts will even
            be able to follow along with real-time location tracking."
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="“The addition of Lifeline to our mobile platform is a huge step in ensuring AllTrails users feel connected and confident while exploring in
          the outdoors,” said Jade Van Doren, CEO of AllTrails. “Made for people heading out on their own, and for those exploring in more remote
          areas, we felt it was important to provide the peace of mind and security that comes from your loved ones knowing your plan, where you are,
          and getting automatic alerts if something goes wrong.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="With the new Lifeline feature AllTrails Pro subscribers can select up to five contacts to receive a unique tracking URL to view their i)
          planned route on an easy-to-read map, ii) planned starting and ending locations iii) planned start and finish time, iv) total tracked
          distance and elevation gain, and v) real-time location on a map plotted against the planned route."
          />
          <br />
          <FormattedMessage
            defaultMessage="Once a user completes their activity out on the trail and marks themself as safe, their safety contacts will be notified. If an AllTrails
          Pro subscriber is overdue for their scheduled finish time, safety contacts will automatically receive an alert with the user's last known
          GPS coordinates. Safety contacts do not have to be AllTrails users or subscribers to watch the user's progress on the trail and receive
          alerts."
          />
          <br />
          <FormattedMessage
            defaultMessage="Similar to other location tracking mobile apps, Lifeline does require a data signal when setting up the feature and real-time tracking is
          dependent on a data connection. Many features of the AllTrails app are available with a free account, and AllTrails Pro can be purchased for
          $29.99/year, or $99.99/lifetime."
          />
          <br />
          <FormattedMessage
            defaultMessage="For more information on {alltrailsLink} or the AllTrails {iosLink} or {androidLink} mobile app please contact {pressLink}."
            values={{ alltrailsLink, iosLink, androidLink, pressLink }}
          />
        </Typography>
      </>
    )
  },
  {
    cardType: 'press-release',
    title: <FormattedMessage defaultMessage="AllTrails Celebrates One Million Mobile Installs" />,
    date: 'Nov 07, 2012',
    modalContent: (
      <>
        <Typography variant="heading400" component="h2">
          <FormattedMessage
            defaultMessage="AllTrails, the Leading Digital Network for Outdoor Enthusiasts, Celebrates One Million Mobile Installs and Announces the Retail Launch of
          The Ultimate Outdoor MapKit"
          />
        </Typography>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="{alltrailsLink}, the leading digital network focused on outdoor enthusiasts, announced today that
            it has seen more than 1 million installs of its industry-leading mobile applications, as well as the launch of its premium subscription
            service in over 200 retailers nationwide including REI, EMS, Sport Chalet and Bass Pro Shops. "
            values={{ alltrailsLink }}
          />
          <br />
          <FormattedMessage
            defaultMessage="AllTrails released its first mobile application in 2011, which quickly became one of the top outdoor apps for the iPhone. AllTrails for
          Android was released one year ago, and has quickly surged in popularity in the Google Play store — garnering a spot among the Top 25 Travel
          Apps and over half a million installs."
          />
          <br />
          <FormattedMessage
            defaultMessage="“The growth we are seeing on mobile is tremendous,” says Justin Ip, Head of Product at AllTrails. “When we launched our Android app last
          year we never dreamt that it would so quickly overtake the huge head start of our iPhone application. In one year, we have seen half a
          million users download the app through Google Play. I believe our growing base of mobile app users will be delighted by the pace of
          innovation we have planned for the platform this coming year.”"
          />
          <br />
          <FormattedMessage
            defaultMessage="The rapid adoption of smartphones was a major driving force behind bringing the AllTrails premium subscription service to retail. The
          product will be sold under the name “The Ultimate Outdoor MapKit” and will be co-branded under both the AllTrails and National Geographic
          brands. Customers purchasing MapKit through their favorite outdoor retailer will be able to redeem their purchase for 1 year of access to
          AllTrails Pro. This provides them with unlimited access to National Geographic TOPO! and Trails Illustrated maps, as well as advanced
          trip-planning tools which can be accessed online through a web browser, and offline on a smartphone or by printing maps on-demand."
          />
          <br />
          <FormattedMessage
            defaultMessage="“It's not often that a software startup gets the opportunity to help design packaging and take a physical product to market,” says Russell
          Cook, Founder & CEO of AllTrails. “The retail expertise of our partners at National Geographic has been invaluable, and we have been
          overwhelmed by the positive response of retailers. Retailers are seeing consumers do more on their mobile devices and they are looking for
          products like MapKit that allow them to better serve those customers. We're excited to be working with National Geographic and their
          retailer partners to provide outdoor enthusiasts seamless access to outdoor recreation maps and information, whether online or offline.”"
          />
        </Typography>
      </>
    )
  }
];

export default oldPressReleases;
